import { applyLoadActionClass } from "./skyward.ui.events";
import { notifyDOMLoad } from "./skyward.ui.window";
import { Skyward } from "./types";
import { createAppWithRootComponent, PropsOf } from "./vue/core/vueHelpers";
import { SkyVueTypes } from "./vue/skyVue";
import { SkyVueData } from "./vue/skyVue/core/store/types";
import { getHtmlDataAttributes } from "./vue/skyVue/core/utilities";

window.skyward.base.registerScript("skyVue", function (_skyward: Skyward, _$: JQueryStatic)
{
    const events =
    {
        init
    };

    return events;

    function init(this: JQuery<HTMLElement>)
    {
        const element = this;
        const domElement = element[0];
        const skyVueData = element.data("skyvue") as SkyVueData;
        const component = SkyVueTypes[skyVueData.key];
        const props = {
            skyVueData,
            class: skyVueData.classNames,
            ...getHtmlDataAttributes(skyVueData.htmlData)
        } as PropsOf<typeof component>;
        let vm = createAppWithRootComponent(component, props);
        vm.mount(domElement);

        if (element.data("reloaded") !== true)
        {
            const observer = new MutationObserver(() =>
            {
                if (!document.body.contains(domElement))
                {
                    observer.disconnect();
                    vm.unmount();
                }
            });

            observer.observe(document.body,
                {
                    childList: true,
                    subtree: true
                });

            $(document.body).on("DOMInsertionPreLoad", function (event: JQuery.TriggeredEvent)
            {
                if (event.target && (event.target as HTMLElement).contains(domElement))
                {
                    vm.unmount();
                }
            });

            element.on("refresh", function (event: JQuery.TriggeredEvent)
            {
                event.stopPropagation();
                // Use a timeout to defer the unmout.  
                // Without it, resize callbacks will be modified while being iterated which causes issues
                window.setTimeout(function ()
                {
                    vm.unmount();
                    const element = $(event.target);
                    element.data("reloaded", true);
                    applyLoadActionClass(element);
                    notifyDOMLoad(element);
                }, 0);
            });
        }
    }
});